/* MD size guide — overlay + trigger. Data comes from [data-size-guide-data]. */
(function(){
  var node = document.querySelector('[data-size-guide-data]');
  if (!node) return;
  var DATA;
  try { DATA = JSON.parse(String(node.textContent).replace(/,(\s*[\]}])/g, '$1')); }
  catch(e){ if (window.console) console.warn('[size guide] bad data', e); return; }
  if (!DATA.rows || !DATA.rows.length) return;
  var TS = DATA.triggerStyle || {};

  var host, current = null, unit = DATA.defaultUnit || 'cm';

  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function conv(v){
    if (unit === 'cm') return v;
    return String(v).replace(/\d+(?:[.,]\d+)?/g, function(n){
      var x = parseFloat(n.replace(',', '.')) / 2.54;
      return (Math.round(x * 10) / 10).toFixed(1).replace(/\.0$/, '');
    });
  }

  function pick(list, size){
    if (!list) return null;
    for (var i = 0; i < list.length; i++) if (String(list[i].size).toLowerCase() === String(size).toLowerCase()) return list[i];
    return null;
  }
  function row(size){ return pick(DATA.rows, size) || DATA.rows[0]; }

  function measurements(){
    var r = row(current);
    return DATA.cols.map(function(c, i){
      return '<div class="mdsg__m"><span class="mdsg__mname">' + esc(c.label) + '</span>' +
        '<span class="mdsg__mval">' + esc(conv(r.values[i] || '')) + '</span>' +
        (c.note ? '<span class="mdsg__mnote">' + esc(c.note) + '</span>' : '') + '</div>';
    }).join('');
  }

  function bodyBox(){
    if (DATA.showBody === false) return '';
    var r = pick(DATA.bodyRows, current);
    if (!r) return '';
    var rows = DATA.bodyCols.map(function(c, i){
      return '<div class="mdsg__brow"><span>' + esc(c) + '</span><span>' + esc(conv(r.values[i] || '')) + '</span></div>';
    }).join('');
    return '<div class="mdsg__box"><span class="mdsg__label">' + esc(DATA.bodyLabel) + '</span>' + rows +
      (DATA.fitNote ? '<p class="mdsg__fit">' + esc(DATA.fitNote) + '</p>' : '') + '</div>';
  }

  function convBox(){
    if (DATA.showConv === false) return '';
    var r = pick(DATA.convRows, current);
    if (!r) return '';
    var rows = DATA.convCols.map(function(c, i){
      return '<div class="mdsg__m" style="padding:13px 0"><span class="mdsg__mname" style="font-size:13px">' + esc(c) +
        '</span><span class="mdsg__mval" style="font-size:13px">' + esc(r.values[i] || '') + '</span></div>';
    }).join('');
    return '<span class="mdsg__label">' + esc(DATA.convLabel) + ' &middot; ' + esc(current) + '</span>' + rows;
  }

  function table(){
    var head = '<tr><th>' + esc(DATA.tableLabel) + '</th>' + DATA.cols.map(function(c){ return '<th>' + esc(c.label) + '</th>'; }).join('') + '</tr>';
    var body = DATA.rows.map(function(r){
      return '<tr data-row="' + esc(r.size) + '"' + (String(r.size).toLowerCase() === String(current).toLowerCase() ? ' data-on' : '') + '><td>' + esc(r.size) + '</td>' +
        DATA.cols.map(function(c, i){ return '<td>' + esc(conv(r.values[i] || '')) + '</td>'; }).join('') + '</tr>';
    }).join('');
    return '<div class="mdsg__only-desktop"><span class="mdsg__label">' + esc(DATA.tableLabel) + ' &middot; ' + esc(DATA.unitLabel[unit]) +
      '</span><div class="mdsg__tablewrap"><table class="mdsg__table"><thead>' + head + '</thead><tbody>' + body + '</tbody></table></div></div>';
  }

  function help(){
    if (!DATA.help || !DATA.help.title) return '';
    var mail = (DATA.help.text || '').match(/[\w.+-]+@[\w.-]+/);
    var href = DATA.help.url || (mail ? 'mailto:' + mail[0] : '#');
    return '<a class="mdsg__help" href="' + esc(href) + '"><span class="mdsg__helpcopy"><b>' + esc(DATA.help.title) +
      '</b><span>' + esc(DATA.help.text) + '</span></span><svg viewBox="0 0 24 8"><path d="M0 4h22M18 1l4 3-4 3"/></svg></a>';
  }

  function paint(){
    host.querySelector('[data-sg-sizes]').innerHTML = DATA.rows.map(function(r){
      return '<button type="button" class="mdsg__size" data-size="' + esc(r.size) + '" aria-pressed="' +
        (String(r.size).toLowerCase() === String(current).toLowerCase()) + '">' + esc(r.size) + '</button>';
    }).join('');
    Array.prototype.forEach.call(host.querySelectorAll('[data-sg-unit] button'), function(btn){
      btn.setAttribute('aria-pressed', btn.getAttribute('data-unit') === unit);
    });
    host.querySelector('[data-sg-left]').innerHTML =
      '<span class="mdsg__label">' + esc(DATA.garmentLabel) + ', ' + esc(current) + ' &middot; ' + esc(DATA.unitLabel[unit]) + '</span>' +
      measurements() + bodyBox();
    host.querySelector('[data-sg-right]').innerHTML = table() + convBox() + help();
  }

  function build(){
    host = document.createElement('div');
    host.className = 'mdsg-host';
    host.setAttribute('role', 'dialog');
    host.setAttribute('aria-modal', 'true');
    host.hidden = true;
    host.innerHTML =
      '<div class="mdsg__panel">' +
        '<div class="mdsg__bar"><span class="mdsg__barcopy"><span class="mdsg__eyebrow">' + esc(DATA.eyebrow) + '</span>' +
        '<span class="mdsg__title">' + esc(DATA.title) + '</span></span>' +
        '<button type="button" class="mdsg__close" data-sg-close aria-label="Close"><svg viewBox="0 0 20 20"><path d="M4 4l12 12M16 4L4 16"/></svg></button></div>' +
        '<div class="mdsg__scroll">' +
          '<div class="mdsg__tools"><div class="mdsg__sizes" data-sg-sizes></div>' +
          '<div class="mdsg__unit" data-sg-unit><button type="button" data-unit="cm">' + esc(DATA.unitLabel.cm) + '</button>' +
          '<button type="button" data-unit="in">' + esc(DATA.unitLabel['in']) + '</button></div></div>' +
          '<div class="mdsg__cols"><div data-sg-left></div><div data-sg-right></div></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(host);

    host.addEventListener('click', function(e){
      if (e.target === host) return close();
      if (e.target.closest('[data-sg-close]')) return close();
      var chip = e.target.closest('[data-size]'); if (chip){ current = chip.getAttribute('data-size'); return paint(); }
      var tr = e.target.closest('[data-row]'); if (tr){ current = tr.getAttribute('data-row'); return paint(); }
      var u = e.target.closest('[data-unit]'); if (u){ unit = u.getAttribute('data-unit'); return paint(); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && host && !host.hidden) close(); });
  }

  function selectedOnPage(){
    var on = document.querySelector('.sizes .size[aria-pressed="true"]');
    if (on) return on.getAttribute('data-value');
    var sel = document.querySelector('[data-option-select]');
    if (sel && sel.value) return sel.value;
    return null;
  }

  function open(){
    if (!host) build();
    var live = selectedOnPage();
    if (live && pick(DATA.rows, live)) current = live;
    if (!current) current = (DATA.rows[Math.min(DATA.defaultIndex || 0, DATA.rows.length - 1)] || DATA.rows[0]).size;
    paint();
    host.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    if (!host) return;
    host.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function norm(t){ return (t || '').replace(/\s+/g, ' ').trim().toLowerCase().replace(/&amp;/g, '&'); }

  function linkCss(){
    var size = TS.size || 10.5;
    var track = (TS.tracking == null ? 100 : TS.tracking) / 1000;
    return 'display:inline-block;width:auto;background:0;border:0;' +
      (TS.underline === false ? 'border-bottom:0;' : 'border-bottom:1px solid currentColor;') +
      'padding:0 0 2px;margin:0;cursor:pointer;' +
      (TS.color ? 'color:' + TS.color + ';' : 'color:inherit;') +
      'font-family:var(--mono);font-weight:400;font-size:' + size + 'px;line-height:1;letter-spacing:' + track + 'em;' +
      'text-transform:' + (TS.uppercase === false ? 'none' : 'uppercase') + ';text-align:left;opacity:.7';
  }

  /* The trigger lives inside the collapsible row named in DATA.attachHeading. */
  function attach(){
    var wanted = norm(DATA.attachHeading || 'fit & measurements');
    Array.prototype.forEach.call(document.querySelectorAll('.pdp__inner .accordion__item'), function(item){
      var btn = item.querySelector('.accordion__btn span');
      if (!btn) return;
      var label = norm(btn.textContent);
      if (label !== wanted && label.indexOf(wanted) === -1 && wanted.indexOf(label) === -1) return;
      var body = item.querySelector('.accordion__body');
      if (!body || body.querySelector('[data-size-guide-wrap]')) return;
      var wrap = document.createElement('div');
      wrap.setAttribute('data-size-guide-wrap', '');
      wrap.style.cssText = 'display:block;text-align:' + (TS.align || 'left') + ';margin-top:' + (TS.space == null ? 6 : TS.space) + 'px';
      var link = document.createElement('button');
      link.type = 'button';
      link.setAttribute('data-size-guide-open', '');
      link.textContent = DATA.trigger;
      link.style.cssText = linkCss();
      link.addEventListener('mouseenter', function(){ link.style.opacity = '1'; });
      link.addEventListener('mouseleave', function(){ link.style.opacity = '.7'; });
      wrap.appendChild(link);
      body.appendChild(wrap);
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-size-guide-open]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  });

  function boot(){
    attach();
    var pdp = document.querySelector('.pdp__inner');
    if (pdp && !pdp.dataset.sgWatch){
      pdp.dataset.sgWatch = '1';
      new MutationObserver(attach).observe(pdp, { childList: true, subtree: true });
    }
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
  boot();
  [200, 800].forEach(function(ms){ setTimeout(boot, ms); });
})();
